module.exports = __webpack_public_path__ + "static/media/bedwellLogo.9d5f1894.svg";